<template>
  <b-container
    id="app1"
    class="bv-example-row"
    fluid
    style="padding-top: 2rem; padding-bottom: 2rem"
  >
    <b-row class="justify-content-md-center">
      <p></p>
    </b-row>

    <b-row class="justify-content-md-center">
      <div v-if="!memberShow">
        <b-col>
          <img
            class="img-fluid d-block mx-auto"
            alt="產學攜手專班經濟不利助學金系統"
            src="Reports.png"
            style="max-width: 60%"
            title="產學攜手專班經濟不利助學金系統"
          />
          <br />
          <div
            class="form-group frame_title"
            style="text-align: center; font-size: 2em"
          >
            產學攜手專班經濟不利助學金系統
          </div>
          <div style="text-align: center">
            <form method="post" class="mx-auto" style="max-width: 22rem; text-align: left">
              <div class="form-group row align-items-center">
                <label class="col-5 text-right col-form-label">
                  {{ $t("message.ID_txt") }}
                  <b-icon icon="person"></b-icon>：
                </label>
                <div class="col-7">
                  <b-form-input
                    placeholder="請輸入帳號"
                    maxlength="20"
                    v-model="user.id1"
                    :autofocus="true"
                    :clearable="true"
                  ></b-form-input>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label class="col-5 text-right col-form-label">
                  {{ $t("message.PassW_txt") }}
                  <b-icon icon="key"></b-icon>：
                </label>
                <div class="col-7">
                  <b-form-input
                    type="password"
                    placeholder="請輸入密碼"
                    maxlength="20"
                    v-model="user.id2"
                  ></b-form-input>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label class="col-5 text-right col-form-label">
                  {{ $t("message.ValiC_txt") }}
                  <b-icon icon="pencil"></b-icon>：
                </label>
                <div class="col-7 d-flex align-items-center">
                  <b-form-input
                    placeholder="請輸入驗證碼"
                    maxlength="6"
                    style="width: 6em"
                    v-model="user.id3"
                  ></b-form-input>
                  <img
                    v-if="captchaInfo != null"
                    :src="captchaInfo.text2"
                    style="height: 2.75rem; margin-left: 0.3rem"
                    alt=""
                  />
                  <a
                    href="#"
                    style="padding: 0 0.4rem"
                    title="重新產生驗證碼"
                    @click.prevent="getCaptcha()"
                  >
                    <b-icon icon="bootstrap-reboot"></b-icon>
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-7 offset-5 d-flex" style="gap: 0.5rem">
                  <b-button
                    variant="primary"
                    style="width: 6.5rem"
                    @click.prevent="login()"
                  >
                    {{ $t("message.Sign_in") }}
                    <b-icon icon="door-open" />
                  </b-button>
                  <b-button
                    style="width: 6.5rem"
                    type="reset"
                    @click="onReset"
                    variant="danger"
                  >Reset</b-button>
                </div>
              </div>
            </form>
          </div>
          <div
            v-if="EPaper != null"
            class="form-group frame_title"
            style="text-align: center"
          >
            <span style="font-weight: bold"> {{ EPaper.title }}</span
            ><span v-html="EPaper.content"></span>
          </div>
        </b-col>
      </div>
    </b-row>
  </b-container>
</template>
<script>
import * as tools from '../tool'
export default {
  name: 'index',

  data () {
    return {
      memberShow: false,
      em: '',
      content: {
        text1: '',
        text2: ''
      },
      user: {
        id1: '',
        id2: '',
        id3: '',
        sysId: 0, // 學生登入
        isLogin: true
      },

      // captchaInfo:{text1:'',text2:'',text3:''},
      confirmData: null,
      captchaInfo: null,
      inputData: null,
      EPaper: null
    }
  },

  methods: {
    // 标准化字符串，去除空白字符并转换为小写
    normalizeString (str) {
      return str.replace(/\s+/g, '').toLowerCase()
    },
    onReset () {
      this.user.id1 = ''
      this.user.id2 = ''
      this.user.id3 = ''
    },
    checkLoginData () {
      let msg = ''

      if (tools.isNullOrWhiteSpace(this.user.id1)) {
        msg = '學號'
      } else if (tools.isNullOrWhiteSpace(this.user.id2)) {
        msg = '學生篇密碼'
      }

      return msg
    },

    login: function () {
      var vm = this
      var msg = vm.checkLoginData()
      if (msg.length == 0) {
        var info = {
          text1: this.user.id1,
          text2: this.user.id2
        }
      }
      this.$http
        .put('./WebApi/Common/Authorized', this.user)
        .then((response) => {
          vm.inputData = response.data
          if (
            !tools.isNull(vm.inputData) &&
            vm.normalizeString(vm.inputData.usrData.id) === vm.normalizeString(vm.user.id1)
          ) {
            vm.memberShow = true

            this.$store.dispatch('actionLogin2', vm.memberShow)
            this.$store.dispatch('actionLogin2Data', vm.inputData)
            vm.$router.push({ path: 'StdLogin' })
          } else {
            tools.showAlert(vm, 'danger', '請檢查帳號密碼或驗證碼是否輸入正確')
          }
        })
        .catch(function (error) {
          tools.showAlert(
            vm,
            'danger',
            '對不起, 登入失敗, 請檢查帳號密碼或驗證碼是否輸入正確'
          )
        })
    },
    getCaptcha: function () {
      var vm = this
      this.$http
        .get('./WebApi/Common/GetCaptcha/')
        .then((response) => {
          vm.captchaInfo = response.data
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    getMessage: function () {
      var vm = this
      var send = true
      this.$http
        .get('../WebApi/EconomicDisadvantage/GetEPaperDetail2/'.concat(send))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.EPaper = response.data[0]
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
        })
    }
  },
  beforeMount () {
    console.log('======beforeMount index  =====')
    this.getCaptcha()
  },
  created () {
    console.log('======created index  =====')

    this.getMessage()
  }
}
</script>
<style scoped>
</style>
